module.exports = __webpack_public_path__ + "img/colaborador(5).1e98ca98.jpeg";